export function hasContacts(results) {
  if (!results) {
    return false;
  }

  const emails = results.ListEmailsWithMask?.Email?.length > 0;
  const phones = results.ListPhonesWithMask?.PhoneNumber?.length > 0;

  return emails || phones;
}

export const CONTACTS_NOT_FOUND_MESSAGE =
  'Não foi possível localizar contatos para este documento. Verifique os dados informados ou entre em contato pelo WhatsApp.';
